/* eslint-disable prettier/prettier */
export const packingMaterialRegistrations = [
  'IMPORT_PACKING_MATERIALS',
  'UNDERTAKER_OF_THE_PRODUCT_FEE_PAYMENT_OBLIGATION',
  'PACKING_MATERIAL_PRODUCER',
  'NONE',
] as const;

export type PackingMaterialRegistration =
  typeof packingMaterialRegistrations[number];
